import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import { Document } from '@savgroup-front-common/types';

interface AdaptClaimDocumentsToVoucherDocumentDataArgs {
  documents?: Document[];
}

export const adaptClaimDocumentsToVoucherDocumentData = ({
  documents,
}: AdaptClaimDocumentsToVoucherDocumentDataArgs): DocumentData[] => {
  return (documents || [])
    .filter(
      (document) =>
        document.name !== DOCUMENT_TYPES.IMAGE && document.customerVisibility,
    )
    .reduce<DocumentData[]>(
      (acc, document) => [
        ...acc,
        {
          ...document,
          type: document.name,
          documentName: document.name || '',
          counter:
            acc.filter((d) => d.type === DOCUMENT_TYPES.BILLING).length + 1,
        },
      ],
      [],
    );
};
